<template>
    <div>
        <table class="table table-bordered responsive-table" id="recent_calls">
            <thead>
            <tr>
                <th>User</th>
                <th>Modify from</th>
                <th>Field Label</th>
                <th>Field Type</th>
<!--                <th>Display Name</th>-->
                <th>Action</th>
                <th>old data</th>
                <th>new data</th>
                <th>Old attachment</th>
                <th>New attachment</th>
                <th>date</th>
                <th>IP</th>
            </tr>
            </thead>
            <tbody id="recentCalls">
            <tr v-for="item in items">
                <td>{{ item.user_name }}</td>
                <td> {{ item.service_name }}</td>
                <td>  {{ item.attribute_name }}</td>
<!--                <td>  {{ // item.attribute_type }}</td>-->
                <td>  {{ item.display_name }}</td>
                <td>  {{ item.type }}</td>
                <td>
                    <table>
                      <tr v-if="item.old_description[0]['attribute_name'] != item.description[0]['attribute_name']">
                        <td>Field label  : </td>
                        <td>{{item.old_description[0]['attribute_name']}}</td>
                      </tr>
                      <tr v-if="item.old_description[0]['extra_info'] != item.description[0]['extra_info']">
                        <td >Helper text  : </td>
                        <td v-html="item.old_description[0]['extra_info']"></td>
                      </tr>
                      <tr v-if="item.old_description[0]['attribute_variable_name'] != item.description[0]['attribute_variable_name']">
                        <td>Field ID : </td>
                        <td>{{item.old_description[0]['attribute_variable_name']}}</td>
                      </tr>
                      <tr v-if="item.old_description[0]['is_hidden'] != item.description[0]['is_hidden']">
                        <td>Active : </td>
                        <td v-if="item.old_description[0]['is_hidden']">No</td>
                        <td v-else="item.old_description[0]['is_hidden']">Yes</td>
                      </tr>
                      <tr  v-if="item.old_description[0]['is_hidden_customer'] != item.description[0]['is_hidden_customer']">
                        <td>Hidden from customer portal : </td>
                        <td v-if="item.old_description[0]['is_hidden_customer']">Yes</td>
                        <td v-else="item.old_description[0]['is_hidden_customer']">No</td>
                      </tr>
                      <tr  v-if="item.old_description[0]['default_follow_up_period'] != item.description[0]['default_follow_up_period']">
                        <td> Default Service Reminder Interval (Days) for Custom Field Option: </td>
                        <td v-if="item.old_description[0]['default_follow_up_period']">Yes</td>
                        <td v-else="item.old_description[0]['default_follow_up_period']">No</td>
                      </tr>
                      <tr  v-if="item.old_description[0]['display_price_customer'] != item.description[0]['display_price_customer']">
                        <td> Display pricing on view service page : </td>
                        <td v-if="item.old_description[0]['display_price_customer']">Yes</td>
                        <td v-else="item.old_description[0]['display_price_customer']">No</td>
                      </tr>
                      <tr v-if="item.old_description[0]['is_hidden_inquiry_widget'] != item.description[0]['is_hidden_inquiry_widget']">
                        <td> Hidden from lead capture form : </td>
                        <td v-if="item.old_description[0]['is_hidden_inquiry_widget']">Yes</td>
                        <td v-else="item.old_description[0]['is_hidden_inquiry_widget']">No</td>
                      </tr>
                      <tr v-if="item.old_description[0]['is_hidden_invoice'] != item.description[0]['is_hidden_invoice']">
                        <td> Hidden from invoice breakdown : </td>
                        <td v-if="item.old_description[0]['is_hidden_invoice']">Yes</td>
                        <td v-else="item.old_description[0]['is_hidden_invoice']">No</td>
                      </tr>
                      <tr v-if="item.old_description[0]['mandatory'] != item.description[0]['mandatory']">
                        <td> Mandatory: </td>
                        <td v-if="item.old_description[0]['mandatory']">Yes</td>
                        <td v-else="item.old_description[0]['mandatory']">No</td>
                      </tr>
                      <tr v-if="item.old_description[0]['searchable'] != item.description[0]['searchable']">
                        <td> Searchable: </td>
                        <td v-if="item.old_description[0]['searchable']">Yes</td>
                        <td v-else="item.old_description[0]['searchable']">No</td>
                      </tr>
                      <tr v-if="item.old_description[0]['is_price_attribute'] != item.description[0]['is_price_attribute']">
                        <td> Affects The Service Price : </td>
                        <td v-if="item.old_description[0]['is_price_attribute']">Yes</td>
                        <td v-else="item.old_description[0]['is_price_attribute']">No</td>
                      </tr>
                      <tr v-if="item.old_description[0]['values_order'] != item.description[0]['values_order']">
                        <td> Selections display order: </td>
                        <td>{{item.old_description[0]['values_order']}}</td>
                      </tr>
                      <tr v-if="item.old_description[2]" >
                        <td v-if="item.old_description[0]['unit_price'] != item.description[0]['unit_price']"> Unit Price: </td>
                        <td v-if="item.old_description[0]['unit_price'] != item.description[0]['unit_price']">{{item.old_description[2]['unit_price']}}</td>
                      </tr>
                      <tr v-if="item.old_description[2]">
                        <td v-if="item.old_description[0]['cost_type'] != item.description[0]['cost_type']"> Cost Type: </td>
                        <td v-if="item.old_description[0]['cost_type'] != item.description[0]['cost_type']">{{item.old_description[2]['cost_type']}}</td>
                      </tr>
                      <tr v-if="item.old_description[2]">
                        <td v-if="item.old_description[0]['service_attribute_additional_time'] != item.description[0]['service_attribute_additional_time']"> Additional Time: </td>
                        <td v-if="item.old_description[0]['service_attribute_additional_time'] != item.description[0]['service_attribute_additional_time']">{{item.old_description[2]['service_attribute_additional_time']}}</td>
                      </tr>
                      <tr v-if="item.old_description[0]['min'] != item.description[0]['min']">
                        <td>Min : </td>
                        <td>{{item.old_description[0]['min']}}</td>
                      </tr>
                      <tr v-if="item.old_description[0]['max'] != item.description[0]['max']">
                        <td>Max : </td>
                        <td>{{item.old_description[0]['max']}}</td>
                      </tr>
                        <tr v-if="item.old_description[0]['default_value'] != item.description[0]['default_value']">
                            <td>Default Value : </td>
                            <td>{{item.old_description[0]['default_value']}}</td>
                        </tr>
                        <tr v-if="item.status_diff">
                            <td>Options : </td>
                            <td></td>
                        </tr>
                      <tr v-for="(itemattr ,index) in item.old_description[3]">
                        <td v-if=" itemattr['attribute_value'] != item.description[3][index]['attribute_value']">attribute value : </td>
                        <td v-if=" itemattr['attribute_value'] != item.description[3][index]['attribute_value']">{{itemattr['attribute_value']}}</td>
                      </tr>
                      <tr v-for="(itemattr ,index) in item.old_description[3]">
                        <td v-if=" itemattr['unit_price'] != item.description[3][index]['unit_price']">Unit Price : </td>
                        <td v-if=" itemattr['unit_price'] != item.description[3][index]['unit_price']">{{itemattr['unit_price']}}</td>
                      </tr>
                      <tr v-for="(itemattr ,index) in item.old_description[3]">
                        <td v-if=" itemattr['cost_type'] != item.description[3][index]['cost_type']">Cost Type: : </td>
                        <td v-if=" itemattr['cost_type'] != item.description[3][index]['cost_type']">{{itemattr['cost_type']}}</td>
                      </tr>
                    </table>
<!--                    {{ item.old_description }}-->
                    </td>
                <td>
                    <table  v-if="item.type == 'update'">
                        <tr v-if="item.old_description[0]['attribute_name'] != item.description[0]['attribute_name']">
                            <td>Field label  : </td>
                            <td>{{item.description[0]['attribute_name']}}</td>
                        </tr>
                        <tr v-if="item.old_description[0]['attribute_variable_name'] != item.description[0]['attribute_variable_name']">
                          <td>Field Id  : </td>
                          <td>{{item.description[0]['attribute_variable_name']}}</td>
                        </tr>
                        <tr v-if="item.old_description[0]['extra_info'] != item.description[0]['extra_info']">
                            <td>Helper text  : </td>
                            <td v-html="item.description[0]['extra_info']"></td>
                        </tr>
                        <tr v-if="item.old_description[0]['is_hidden'] != item.description[0]['is_hidden']">
                            <td>Active : </td>
                            <td v-if="item.description[0]['is_hidden']">No</td>
                            <td v-else="item.description[0]['is_hidden']">Yes</td>
                        </tr>
                        <tr v-if="item.old_description[0]['is_hidden_customer'] != item.description[0]['is_hidden_customer']">
                            <td>Hidden from customer portal : </td>
                            <td v-if="item.description[0]['is_hidden_customer']">Yes</td>
                            <td v-else="item.description[0]['is_hidden_customer']">No</td>
                        </tr>
                        <tr v-if="item.old_description[0]['default_follow_up_period'] != item.description[0]['default_follow_up_period']">
                            <td> Default Service Reminder Interval (Days) for Custom Field Option: </td>
                            <td v-if="item.description[0]['default_follow_up_period']">Yes</td>
                            <td v-else="item.description[0]['default_follow_up_period']">No</td>
                        </tr>
                      <tr v-if="item.old_description[0]['display_price_customer'] != item.description[0]['display_price_customer']">
                        <td> Display pricing on view service page : </td>
                        <td v-if="item.description[0]['display_price_customer']">Yes</td>
                        <td v-else="item.description[0]['display_price_customer']">No</td>
                      </tr>
                      <tr v-if="item.old_description[0]['is_hidden_inquiry_widget'] != item.description[0]['is_hidden_inquiry_widget']">
                        <td> Hidden from lead capture form : </td>
                        <td v-if="item.description[0]['is_hidden_inquiry_widget']">Yes</td>
                        <td v-else="item.description[0]['is_hidden_inquiry_widget']">No</td>
                      </tr>
                      <tr v-if="item.old_description[0]['is_hidden_invoice'] != item.description[0]['is_hidden_invoice']">
                        <td> Hidden from invoice breakdown : </td>
                        <td v-if="item.description[0]['is_hidden_invoice']">Yes</td>
                        <td v-else="item.description[0]['is_hidden_invoice']">No</td>
                      </tr>
                        <tr v-if="item.old_description[0]['mandatory'] != item.description[0]['mandatory']">
                            <td> Mandatory: </td>
                            <td v-if="item.description[0]['mandatory']">Yes</td>
                            <td v-else="item.description[0]['mandatory']">No</td>
                        </tr>
                      <tr v-if="item.old_description[0]['searchable'] != item.description[0]['searchable']">
                        <td> Searchable: </td>
                        <td v-if="item.description[0]['searchable']">Yes</td>
                        <td v-else="item.description[0]['searchable']">No</td>
                      </tr>
                      <tr v-if="item.old_description[0]['is_price_attribute'] != item.description[0]['is_price_attribute']">
                        <td> Affects The Service Price : </td>
                        <td v-if="item.description[0]['is_price_attribute']">Yes</td>
                        <td v-else="item.description[0]['is_price_attribute']">No</td>
                      </tr>
                      <tr v-if="item.old_description[0]['values_order'] != item.description[0]['values_order']">
                        <td> Selections display order: </td>
                        <td>{{item.description[0]['values_order']}}</td>
                      </tr>
                      <tr v-if="item.description[2]">
                        <td v-if="item.old_description[0]['unit_price'] != item.description[0]['unit_price']"> Unit Price </td>
                        <td v-if="item.old_description[0]['unit_price'] != item.description[0]['unit_price']">{{item.description[2]['unit_price']}}</td>
                      </tr>
                      <tr v-if="item.description[2]">
                        <td v-if="item.old_description[0]['cost_type'] != item.description[0]['cost_type']"> Cost Type: </td>
                        <td v-if="item.old_description[0]['cost_type'] != item.description[0]['cost_type']">{{item.description[2]['cost_type']}}</td>
                      </tr>
                      <tr v-if="item.description[2]">
                        <td v-if="item.old_description[0]['service_attribute_additional_time'] != item.description[0]['service_attribute_additional_time']"> Additional Time: </td>
                        <td v-if="item.old_description[0]['service_attribute_additional_time'] != item.description[0]['service_attribute_additional_time']">{{item.description[2]['service_attribute_additional_time']}}</td>
                      </tr>
                      <tr v-if="item.description[2]">
                        <td> Additional time: </td>
                        <td>Hours</td>
                      </tr>
                        <tr v-if="item.old_description[0]['cost_type'] != item.description[0]['cost_type']">
                            <td> Cost Type: </td>
                            <td>{{item.description[0]['cost_type']}}</td>
                        </tr>
                        <tr v-if="item.old_description[0]['attribute_additional_time'] != item.description[0]['attribute_additional_time']">
                            <td>Additional Time : </td>
                            <td>{{item.description[0]['attribute_additional_time']}}</td>
                        </tr>
                        <tr v-if="item.old_description[0]['min'] != item.description[0]['min']">
                          <td>Min : </td>
                          <td>{{item.description[0]['min']}}</td>
                        </tr>
                        <tr v-if="item.old_description[0]['max'] != item.description[0]['max']">
                          <td>Max : </td>
                          <td>{{item.description[0]['max']}}</td>
                        </tr>
                        <tr v-if="item.old_description[0]['attribute_value'] != item.description[0]['attribute_value']">
                            <td>Default Value : </td>
                            <td>{{item.description[0]['attribute_value']}}</td>
                        </tr>
                       <tr v-if="item.status_diff">
                            <td>Options : </td>
                            <td></td>
                        </tr>
                        <tr v-for="(itemattr ,index) in item.description[3]">
                          <td v-if=" itemattr['attribute_value'] != item.old_description[3][index]['attribute_value']">attribute value : </td>
                          <td v-if=" itemattr['attribute_value'] != item.old_description[3][index]['attribute_value']">{{itemattr['attribute_value']}}</td>
                        </tr>

                        <tr v-for="(itemattr ,index) in item.description[3]">
                          <td v-if=" itemattr['unit_price'] != item.old_description[3][index]['unit_price']">Unit Price : </td>
                          <td v-if=" itemattr['unit_price'] != item.old_description[3][index]['unit_price']">{{itemattr['unit_price']}}</td>
                        </tr>
                        <tr v-for="(itemattr ,index) in item.description[3]">
                          <td v-if=" itemattr['cost_type'] != item.old_description[3][index]['cost_type']">Cost Type: : </td>
                          <td v-if=" itemattr['cost_type'] != item.old_description[3][index]['cost_type']">{{itemattr['cost_type']}}</td>
                        </tr>
                    </table>
<!--                    {{ item.description }}-->
                    </td>
                  <td v-if="item.path_log"> <img v-bind:src="item.path_log"  width="100" height="100"/></td>
                  <td v-else></td>
                  <td v-if="item.path_old_log"> <img v-bind:src="item.path_old_log"  width="100" height="100"/></td>
                  <td v-else></td>
              <td> {{ item.date }}</td>
              <td> {{ item.ip }}</td>
            </tr>
            </tbody>
        </table>
        <transition name="fade">
            <div class="loading" v-show="loading">
                <span class="fa fa-spinner fa-spin"></span> Loading
            </div>
        </transition>
        <nav>
            <ul class="pagination">
                <li v-if="currentPage > 1">
                    <a @click="viewPage(1,total_records)" href="javascript:void(0);">First</a>
                </li>
                <li v-if="currentPage > 1">
                    <a @click="viewPage(currentPage - 1,total_records)" href="javascript:void(0);"> << </a>
                </li>
                <li v-for="page in pages" v-if="(page - currentPage < 3 || page < 6 ) && (currentPage - page < 3 || page < pages.length-6)"
                    :class="{'active':currentPage === page}">
                    <a @click="viewPage(page,total_records)" href="javascript:void(0);">{{ page }}</a>
                </li>
                <li v-if="currentPage < pages">
                    <a @click="viewPage(currentPage +1,total_records)" href="javascript:void(0);"> >> </a>
                </li>
                <li v-if="currentPage < pages">
                    <a @click="viewPage(pages,total_records)" href="javascript:void(0);">Last</a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import {getattrbuitelogs} from "@/modules/Reports/api/customfieldlogs";
import axios from "axios";
export default {
    name: "CustomFieldLogs",
    data() {
        return {
            loading: false,
            items: [],
            pages: null,
            message: '',
            currentPage: 1,
            total_records:false,
        }
    },
    mounted() {
        // Detect when scrolled to bottom.
        this.viewPage(this.currentPage)
    },
    methods: {
        viewPage(page,total_records) {
            this.currentPage = page;
            axios.get("/dashboard/getattrbuitelogs?page=" + page+"&total_records="+total_records).then(response => {
                this.items = response.data.items;
                this.pages = response.data.pages;
                this.total_records = response.data.total_records;
            });
        },
        isScrolledIntoView(elem) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();
            var elemTop = $(elem).offset().top;
            var elemBottom = elemTop + $(elem).height();
            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }
    }
}
</script>

<style scoped>
.ibox-content {
    background-color: #d9dee1 !important
}
</style>